import { render, staticRenderFns } from "./LegalPayDetail.vue?vue&type=template&id=10a5735a&"
import script from "./LegalPayDetail.vue?vue&type=script&lang=js&"
export * from "./LegalPayDetail.vue?vue&type=script&lang=js&"
import style0 from "./LegalPayDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports